export const defaultBTColor = '#0070b9';
export const defaultBTColorDark = '#003366';
export const defaultBTColorLight = '#20a2ff';
